import { useToast as usePrimeToast } from 'primevue/usetoast';

export function useToast() {
    const toast = usePrimeToast();

    const showSuccess = (message, detail = null) => {
        toast.add({
            severity: 'success',
            summary: 'Success',
            detail: message || detail || 'Operation completed successfully',
            life: 5000
        });
    };

    const showError = (message, detail = null) => {
        toast.add({
            severity: 'error',
            summary: 'Error',
            detail: message || detail || 'An error occurred',
            life: 7000
        });
    };

    const showInfo = (message, detail = null) => {
        toast.add({
            severity: 'info',
            summary: 'Information',
            detail: message || detail,
            life: 4000
        });
    };

    const showWarning = (message, detail = null) => {
        toast.add({
            severity: 'warn',
            summary: 'Warning',
            detail: message || detail,
            life: 5000
        });
    };

    return {
        showSuccess,
        showError,
        showInfo,
        showWarning
    };
}
